module.exports = __webpack_public_path__ + "static/media/correct_green.ac9bb5ef.svg";